<div class="row m-3">
  @for (contact of clientContacts; track contact.id) {
    
    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Nom :</span>
      <p>{{ contact.name }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Prénom :</span>
      <p>{{ contact.firstName }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Client :</span>
      <p>{{ contact.client.socialReason }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Adresse :</span>
      <p>{{ contact.address }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Code postal :</span>
      <p>{{ contact.postalCode }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Ville :</span>
      <p>{{ contact.city }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Poste :</span>
      <p>{{ contact.job }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">E-mail :</span>
      <p>{{ contact.email }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Téléphone bureau :</span>
      <p>{{ contact.phone }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Téléphone mobile :</span>
      <p>{{ contact.mobilePhone }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Statut :</span>
      <p>{{ contact.flag ? 'Actif' : 'Inactif' }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Créé le :</span>
      <p>{{ contact.creationDate | date:'dd/MM/yyyy' }}</p>
    </div>

    <div class="col-md-4 col-lg-3 mt-3">
      <span class="label">Mis à jour le :</span>
      <p>{{ contact.updateDate | date:'dd/MM/yyyy' }}</p>
    </div>

    <hr class="mt-3" *ngIf="!$last">
  } @empty {
    <p>0 contact client enregistré.</p>
  }
</div>
